import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Link } from "react-router-dom";

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-void font-mono text-ink">
      <Navbar />
      <div className="mx-auto max-w-4xl px-6 py-24 sm:px-10">
        <Link to="/" className="mb-8 inline-block text-[10px] tracking-widest text-cyanx hover:text-white transition-colors">
          &lt; RETURN TO SECTOR 1
        </Link>
        <h1 className="mb-12 font-poster text-4xl text-fog">DATENSCHUTZ</h1>
        <div className="space-y-8 text-sm leading-relaxed text-fog">
          <section>
            <h2 className="mb-4 text-cyanx">1. Data Protection at a Glance</h2>
            <p>The following information provides a simple overview of what happens to your personal data when you visit our website. Personal data means all data by which you can be personally identified.</p>
          </section>

          <section>
            <h2 className="mb-4 text-cyanx">2. Data Collection on Our Website</h2>
            <p><strong>Who is responsible for the data collection on this website?</strong></p>
            <p className="mb-4">The data processing on this website is carried out by the website operator. Their contact details can be found in the imprint of this website.</p>
            
            <p><strong>How do we collect your data?</strong></p>
            <p className="mb-4">Some data is collected when you provide it to us. This could, for example, be data you enter into a contact form or during order processing.</p>
            
            <p>Other data is collected automatically by our IT systems when you visit the website. This data is primarily technical data such as the browser and operating system you are using or when you accessed the page.</p>
          </section>

          <section>
            <h2 className="mb-4 text-cyanx">3. What do we use your data for?</h2>
            <p>Part of the data is collected to ensure the proper functioning of the website. Other data can be used to analyze how visitors use the site and process orders.</p>
          </section>

          <section>
            <h2 className="mb-4 text-cyanx">4. What rights do you have regarding your data?</h2>
            <p>You always have the right to request information about your stored data, its origin, its recipients, and the purpose of its collection at no charge. You also have the right to request that it be corrected, blocked, or deleted. You can contact us at any time using the address given in the legal notice if you have further questions about the issue of privacy and data protection.</p>
          </section>

          <section>
            <h2 className="mb-4 text-cyanx">5. Payment Processing</h2>
            <p><strong>Stripe</strong></p>
            <p className="mb-4">We use Stripe for payment processing. The provider is Stripe Payments Europe, Ltd., 1 Grand Canal Street Lower, Grand Canal Dock, Dublin, Ireland. When you choose to pay via Stripe, your payment details are transmitted to Stripe. The transmission of your data to Stripe is based on Art. 6 (1) (b) GDPR (processing for the performance of a contract).</p>
            <p><strong>WooCommerce</strong></p>
            <p>We use WooCommerce to manage our online store. During the checkout process, information such as your name, email address, and shipping details will be processed to fulfill your order in accordance with Art. 6 (1) (b) GDPR.</p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
}
